<template>
  <div
    class="bg-background-neutral-secondary flex items-center space-x-4 rounded-2xl px-4"
  >
    <div
      class="text-text-neutral-primary divide-situational-lightgrey flex w-full flex-col divide-y py-2 text-base font-semibold"
    >
      <SearchFormInput
        class="pb-4"
        :text="formattedCities.dep.value"
        :suffix="formattedCities.dep.suffix"
        :has-error="validation.dep.$error"
        :placeholder="t('departure')"
        @click="emit('onFromInputClick')"
      />
      <SearchFormInput
        class="pt-4"
        :text="formattedCities.arr.value"
        :suffix="formattedCities.arr.suffix"
        :has-error="validation.arr.$error"
        :placeholder="t('arrival')"
        @click="emit('onToInputClick')"
      />
    </div>
    <button
      type="button"
      class="rounded-full active:shadow-md"
      @click="emit('onSwap')"
    >
      <!-- prettier-ignore -->
      <svg :class="formattedCities.arr.value && formattedCities.dep.value ? 'text-text-positive-primary' : 'text-text-neutral-quaternary'" aria-labelledby="desc" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M20.158 14.204a1 1 0 0 1-.002 1.414l-4.7 4.69a1 1 0 0 1-1.706-.708V4.4a1 1 0 1 1 2 0v12.79l2.994-2.988a1 1 0 0 1 1.414.002ZM9.633 3.476a1 1 0 0 1 .617.924v15.2a1 1 0 1 1-2 0V6.814L5.257 9.807a1 1 0 1 1-1.414-1.414l4.7-4.7a1 1 0 0 1 1.09-.217Z" clip-rule="evenodd"/><title id="desc">Поменять местами аэропорты вылета и прилета</title></svg>
    </button>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { searchForm, type MappedLocation } from 'shared';
  import type { Validation } from '@vuelidate/core';

  import SearchFormInput from './SearchFormInput.vue';

  type DirectionValidator = Validation<{
    dep: {
      code: {
        requiredDep: boolean;
      };
      isSameDeparture: boolean;
    };
    arr: {
      code: {
        requiredArr: boolean;
      };
      isSameArrival: boolean;
    };
  }>;

  const props = defineProps<{
    dep?: MappedLocation;
    arr?: MappedLocation;
    validation: DirectionValidator;
    source: string;
  }>();

  const emit = defineEmits<{
    onToInputClick: [];
    onFromInputClick: [];
    onSwap: [];
  }>();

  const { t } = useI18n();

  const formattedCities = computed(() =>
    searchForm.lib.formatSearchCities(props.dep, props.arr),
  );
</script>

<i18n src="./locales.json"></i18n>
